import React from 'react';

/**
 * AutoCheckbox renders a small Bootstrap checkbox labelled "AUTO".
 *
 * Used for insurance fields where the premium is automatically deducted
 * from the client's wages rather than paid directly.
 *
 * @param {string}   id
 * @param {boolean}  checked
 * @param {function} onChange  - Called with the new boolean value.
 * @param {string}   [label]   - Override the default "AUTO" label.
 */
export default function AutoCheckbox({
  id,
  checked,
  onChange,
  label = 'AUTO — automatically deducted from wages',
}) {
  return (
    <div className="form-check form-check-inline mb-2">
      <input
        className="form-check-input"
        type="checkbox"
        id={id}
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className="form-check-label text-muted small" htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
